import { ReactElement } from 'react'
import {
  FlexWrapper,
  DropdownWrapper,
  EditableDropdown,
  Input,
  Button,
  TostMessage
} from '../../../components'
import { materialType } from './const'
import strings from '../../../locale/en'
import SecondaryButton from 'react-bootstrap/Button'
import Text from './Text'
import Video from './Video'
import Snyposis from './Snyposis'
import Image from './Image'
import NewMaterialProps from './type'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import {
  setType,
  setSequenceNumber,
  setMaterialTitle,
  saveMaterial,
  setError
} from '../../../redux/addMaterial/actions'
import { useHistory } from 'react-router-dom'

const NewMaterial = ({ topicId }: NewMaterialProps): ReactElement => {
  const {
    type,
    sequenceNumber,
    materialTitle,
    text,
    image,
    synposis,
    video,
    error
  } = useSelector((state: RootState) => state.addMaterial, shallowEqual)
  const dispatch = useDispatch()
  const history = useHistory()

  const onSave = () => {
    const formData = new FormData()
    formData.append('courseId', topicId)
    formData.append('status', 'active')
    formData.append('materialType', type)
    formData.append('title', materialTitle)
    formData.append('orderSequence', sequenceNumber)

    if (type === 'text' || type === 'video') {
      formData.append('textOrURL', type === 'text' ? text : video?.url)
      formData.append('chatUrl', type === 'video' ? '' : video?.chat)
    }

    if (type === 'image' || type === 'snyposis') {
      formData.append('file', type === 'image' ? image : synposis)
    }

    dispatch(saveMaterial(formData))
  }

  const isMaterialMissing = (): boolean => {
    switch (type) {
      case 'text':
        return !text
      case 'image':
        return !image
      case 'snyposis':
        return !synposis
      default:
        return !video.url || !video.chat
    }
  }

  const isDisabled = !topicId || !type || !sequenceNumber || isMaterialMissing()

  const {
    menu: {
      material: { selectMaterial, material, sequence, title }
    },
    button: { save, cancel }
  } = strings

  const renderMaterialType = () => {
    switch (type) {
      case 'text':
        return <Text />
      case 'snyposis':
        return <Snyposis />
      case 'image':
        return <Image />
      case 'video':
        return <Video />
    }
  }

  return (
    <>
      <TostMessage
        show={!!error}
        onCloseHandler={() => dispatch(setError(''))}
        message={error}
      ></TostMessage>
      <FlexWrapper noPadding>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={materialType}
            title={selectMaterial}
            placeholder={material}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              dispatch(setType(item.id))
              dispatch(setSequenceNumber(''))
              dispatch(setMaterialTitle(''))
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Input
            label={sequence}
            isRequired
            placeholder={sequence}
            value={sequenceNumber}
            name="sequence"
            inputType="number"
            onBlur={() => {}}
            onChange={(value) => {
              dispatch(setSequenceNumber(value))
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Input
            label={title}
            placeholder={title}
            value={materialTitle}
            name="sequence"
            onBlur={() => {}}
            onChange={(value) => {
              dispatch(setMaterialTitle(value))
            }}
          />
        </DropdownWrapper>
      </FlexWrapper>
      {type && renderMaterialType()}
      <FlexWrapper justifyContent="center">
        <SecondaryButton
          variant="outline-secondary"
          onClick={() => history.goBack()}
        >
          {cancel}
        </SecondaryButton>
        <Button disabled={isDisabled} onClick={onSave}>
          {save}
        </Button>
      </FlexWrapper>
    </>
  )
}

export default NewMaterial
